import * as React from 'react';

import FileDocs16 from './FileDocs16';

export const fileDocs16 = () => <FileDocs16 />;

export default {
    title: 'Icon|Fill|FileDocs16',
    component: FileDocs16,
    parameters: {
        notes: "`import FileDocs16 from 'box-ui-elements/es/icon/fill/FileDocs16';`",
    },
};
